import { http } from "@/core/api/";

const apiUrl = "api/studentpartcpartb";
export default {
  getInitFilters() {
    return http.get(`${apiUrl}/initfilters`);
  },
  getMonthsByYear(yearId) {
    return http.get(`${apiUrl}/getmonthsbyyear/${yearId}`);
  },
  search(payload) {
    return http.get(`${apiUrl}/search`, {
      params: {
        ...payload
      }
    });
  },
  getStudentSelect() {
    return http.get(`${apiUrl}/infotocreatestudent`);
  },
  getDetailReferal(pcStudentId) {
    return http.get(`${apiUrl}/details/${pcStudentId}`);
  },
  validateCreationPreRegister(pcStudentId) {
    return http.get(`${apiUrl}/validatecreationpreregister/${pcStudentId}`);
  },
  createPreRegister(pcStudentId) {
    return http.post(`${apiUrl}/preregister/${pcStudentId}`);
  },
  saveParentInformation(data) {
    return http.post(`${apiUrl}/parents/save`, data);
  },
  getParents(pcStudentId) {
    return http.get(`${apiUrl}/parents/${pcStudentId}`);
  },
  saveAddressInformation(data) {
    return http.post(`${apiUrl}/address`, data);
  },
  getAddress(pcStudentId) {
    return http.get(`${apiUrl}/address/${pcStudentId}`);
  },
  saveStudent(payload) {
    return http.post(`${apiUrl}/student/save`, payload);
  },
  submitStudent(payload) {
    return http.post(`${apiUrl}/student/submit`, payload);
  },
  save(payload) {
    return http.post(`${apiUrl}/save`, payload);
  },
  submit(payload) {
    return http.post(`${apiUrl}/submit`, payload);
  },
  validateReferralStudent({ pcStudentId, eduespSie }) {
    return http.get(`${apiUrl}/validatestudentsie/${pcStudentId}/${eduespSie}`);
  },
  relateReferralStudent({ pcStudentId, eduespSie }) {
    return http.post(`${apiUrl}/relatestudentsie/${pcStudentId}/${eduespSie}`);
  },
  getRegions(payload) {
    return http.get(`${apiUrl}/regions`, {
      params: {
        ...payload
      }
    });
  },
  getRequestProcedureLogs(id, isOnLineRegistration) {
    return http.get(`${apiUrl}/requestprocedurelogs`, {
      params: {
        id,
        isOnLineRegistration
      }
    });
  },
  saveRequestProcedure(payload) {
    return http.post(`${apiUrl}/saverequestprocedure`, payload);
  },
  deleteRelatedStudentSie(pcStudentId) {
    return http.delete(`${apiUrl}/deleterelatedstudentsie/${pcStudentId}`);
  },
  deleteReferral(pcStudentId) {
    return http.delete(`${apiUrl}/deletereferral/${pcStudentId}`);
  },
  getStatus(statusId, type) {
    return http.get(`${apiUrl}/status/${statusId}/${type}`);
  },
  changeStatus(payload) {
    return http.put(`${apiUrl}/changestatus`, payload);
  },
};
